// Import libraries and functionality
const merge = require('deepmerge');
const equal = require('fast-deep-equal');
const {Spinner} = wp.components;
import { updateCustomThemes, getThemes } from '../utility';

// Import core block libraries
const { Button, Modal, TextControl } = wp.components;
const { __ } = wp.i18n;
const { Component, Fragment } = wp.element;

export default class ManageThemesModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isDirty: false,
			isDirtyModal: false,
			isParseError: false,
			parseErrorMessage: '',
			showSpinner: false,
			modalCustomThemes: {},
		};

		this.close = this.close.bind(this);
		this.save = this.save.bind(this);
		this.cancelIsDirtyModal = this.cancelIsDirtyModal.bind(this);
		this.discardIsDirtyModal = this.discardIsDirtyModal.bind(this);
	}

	componentDidMount() {
		//console.log('componentDidMount: <ManageThemesModal />');
	}

	componentDidUpdate(prevProps, prevState) {
		//console.log('componentDidUpdate: <ManageThemesModal />');

		// This runs whenever the FAQ theme drop down has changed and the themes have changed. e.g. after a new custom theme has been created or one has been deleted.
		// Update the list of custom themes inside modal if custom themes changed.
		if (!equal(this.props.custom_themes, prevProps.custom_themes)) {
			//console.log('UPDATE PROPS componentDidUpdate: <ManageThemesModal />');

			this.setState(
				{ modalCustomThemes: merge(this.props.custom_themes, {}) },
				function () {
					//console.log(this.props.custom_themes);
				}
			);
		}
	}

	// Validate Multiple theme modal for empty theme title.
	validateThemeModal = () => {
		const tmpCustomThemes = merge(this.state.modalCustomThemes, {});
		let isError = false;
		if (Object.keys(tmpCustomThemes).length > 0) {
			const cEntries = Object.entries(tmpCustomThemes);
			for (const [key, value] of cEntries) {
				if ('' === value.label) {
					isError = true;
					break;
				}
			}
		}

		if (isError) {
			this.setState({
				isParseError: true,
				parseErrorMessage: 'Oops! Theme name can not be empty.',
			});
		}
		return isError;
	};

	async save(e) {

		// Check if the Theme modal is valid.
		if (!this.validateThemeModal()) {

			// reset modal fields ready for when it's displayed again, and close modal
			const state = {
				// modalCustomThemes: this.props.custom_themes, // don't need to update this manually
				isDirtyModal: false,
				isDirty: false,
				isParseError: false,
				parseErrorMessage: '',
			};

			// Set the showSpinner to true.
			this.setState({
				showSpinner: true,
			});

			const { coreThemes, endpoint } = this.props;

			// update custom themes in db via endpoint
			const updatedCustomThemes = await updateCustomThemes(
				JSON.stringify(this.state.modalCustomThemes),
				endpoint
			);

			this.setState(state, () => {
				const currentThemeId = JSON.parse(
					this.props.faq_theme_select
				).value;

				//console.log('STATUS: ', JSON.parse(this.props.faq_theme_select), this.props.attributes._theme_type, currentThemeId, this.props.faq_theme_select, this.state.modalCustomThemes);

				// one or more custom themes have been updated and/or deleted so update themes drop down accordingly
				if (this.props.attributes._theme_type === 'custom') {
					// if currently selected theme is a custom theme and is contained in update themes list then update the currently selected theme label in case it has been edited
					if (
						this.state.modalCustomThemes.hasOwnProperty(
							currentThemeId
						)
					) {
						//console.log('CUSTOM BUT FOUND');
						const newSelectedThemeLabel = {
							...JSON.parse(this.props.faq_theme_select),
						};
						newSelectedThemeLabel.label =
							this.state.modalCustomThemes[currentThemeId].label;

						// update current theme label but don't reset customised status
						// @todo today
						this.props.updateThemeList(newSelectedThemeLabel, true);
					} else {
						// this shouldn't happen now as we don't allow a custom theme to be deleted if it's the currently selected theme in the drop down
						//console.log('ERROR - Current drop down theme is custom but can\'t be found in updated theme list.');
					}
				} else {
					//console.log('CORE THEME - JUST UPDATE LIST');
					// update theme list - no need to update the current theme label as it's a core theme
					this.props.updateThemeList();
				}

			});

			// Reset sate to default.
			this.setState({
				showSpinner: false,
			});
			this.props.setManageThemesModalOpenStatus(false);

		}
	}

	cancelIsDirtyModal(e) {
		this.setState({ isDirtyModal: false });
	}

	// discard changes in is dirty modal
	discardIsDirtyModal(e) {
		//console.log('DISCARD CHANGES');

		const state = {
			modalCustomThemes: this.props.custom_themes,
			isDirtyModal: false,
			isDirty: false,
			isParseError: false,
			showSpinner: false,
			parseErrorMessage: '',
		};
		this.setState(state, function () {
			this.props.setManageThemesModalOpenStatus(false);
		});

		//this.setState({ isDirtyModal: false, isDirty: false, parseErrorMessage: '' });
		//setState({ isDirtyModal: false, isManageThemesModalOpen: false, isDirty: false, parseErrorMessage: '' });
	}

	close(e) {
		// @todo (is this still needed?) set the modalCustomThemes state to null again so when modal opened it populates with current custom themes (test)

		//console.log('CLOSE');

		if (this.state.isDirty) {
			this.setState({ isDirtyModal: true, showSpinner: false });
		} else {
			// Do we need to set state here if isDirty === false as state should be unchanged?
			const state = {
				modalCustomThemes: this.props.custom_themes,
				isParseError: false,
			};
			this.setState(state, function () {
				this.props.setManageThemesModalOpenStatus(false);
			});
		}
	}

	// update the custom theme label state via onChange event
	updateThemeName = (key, text) => {
		const tmpCustomThemes = merge(this.state.modalCustomThemes, {}); // clone state object (as the spread operator only copies one level deep)

		tmpCustomThemes[key].label = text;
		this.setState({
			isParseError: false,
			isDirty: true,
			modalCustomThemes: tmpCustomThemes,
		});
	};

	// update the custom theme description via onChange event
	updateThemeDescription = (key, text) => {
		const tmpCustomThemes = merge(this.state.modalCustomThemes, {}); // clone state object (as the spread operator only copies one level deep)

		tmpCustomThemes[key].description = text;
		this.setState({
			isParseError: false,
			isDirty: true,
			modalCustomThemes: tmpCustomThemes,
		});
	};

	// delete a custom theme
	deleteCustomTheme = (key) => {
		const currentThemeId = JSON.parse(this.props.faq_theme_select).value;

		//console.log('DELETE THEME: ', key, JSON.parse(this.props.faq_theme_select), this.props.attributes._theme_type, this.state.modalCustomThemes.hasOwnProperty(currentThemeId));

		if (key === currentThemeId) {
			//console.log('DONT DELETE - SHOW WARNING');

			this.setState({
				isParseError: true,
				parseErrorMessage:
					"Can't delete this custom FAQ theme as it's currently active.",
			});
		} else {
			//console.log('GO AHEAD AND DELETE');

			const tmpCustomThemes = merge(this.state.modalCustomThemes, {}); // clone state object (as the spread operator only copies one level deep)
			delete tmpCustomThemes[key];
			this.setState({
				isParseError: false,
				isDirty: true,
				modalCustomThemes: tmpCustomThemes,
			});
		}
	};

	render() {
		const {
			modalCustomSwitchImmediately,
			isParseError,
			parseErrorMessage,
			isDirtyModal,
			isDirty,
			modalCustomThemes,
			showSpinner,
		} = this.state;

		const ParseErrorMessage = () => (
			<div style={{ fontStyle: 'italic' }} className="parse-error">
				<span className="dashicons dashicons-warning"></span>{' '}
				{parseErrorMessage}
			</div>
		);

		return (
			<Fragment>
				{this.props.isManageThemesModalOpen && (
					<Modal
						title="Manage Custom FAQ Themes"
						shouldCloseOnClickOutside={false}
						onRequestClose={this.close}
						className="modal-duplicate-faq-theme"
					>
						<div className="child-page-listing">
							<div className="grid-container">
								<Fragment>
									<h4 style={{ marginBottom: '15px' }}>
										Edit or delete custom themes.{' '}
										<span style={{ fontStyle: 'italic' }}>
											(
											{
												Object.keys(modalCustomThemes)
													.length
											}{' '}
											found)
										</span>
									</h4>
									{isParseError && <ParseErrorMessage />}

									<table className="render-custom-themes">
										<tbody>
											{Object.entries(
												this.state.modalCustomThemes
											).length === 0 ? (
												<div
													style={{
														fontStyle: 'italic',
													}}
												>
													No custom themes found.
												</div>
											) : (
												Object.entries(
													this.state.modalCustomThemes
												).map(([key, value]) => {
													return (
														<Fragment key={key}>
															<tr className="modal-edit-faq-name">
																<td>
																	<TextControl
																		label="Name"
																		autoComplete="off"
																		data-id={
																			key
																		}
																		value={
																			value.label
																		}
																		onChange={this.updateThemeName.bind(
																			this,
																			key
																		)}
																		onClick={(
																			e
																		) =>
																			e.target.select()
																		}
																	/>
																</td>
																<td>
																	<Button
																		title="Delete theme"
																		variant="secondary"
																		onClick={this.deleteCustomTheme.bind(
																			this,
																			key
																		)}
																	>
																		<span className="dashicons dashicons-no-alt"></span>
																	</Button>
																</td>
															</tr>
															<tr className="modal-edit-faq-description">
																<td>
																	<TextControl
																		label="Description"
																		autoComplete="off"
																		value={
																			value.description
																		}
																		data-id={
																			key
																		}
																		onChange={this.updateThemeDescription.bind(
																			this,
																			key
																		)}
																		onClick={(
																			e
																		) =>
																			e.target.select()
																		}
																	/>
																</td>
															</tr>
														</Fragment>
													);
												})
											)}
										</tbody>
									</table>
									<div style={{ margin: '20px 0' }}></div>
									{isDirtyModal && (
										<div>
											<Modal
												title="Unsaved Changes"
												isDismissable={false}
												className="modal-duplicate-faq-theme-unsaved"
											>
												<div className="modal-discard-changes">
													Discard changes, or go back
													to edit/delete custom theme
													details?
												</div>
												<div className="modal-buttons">
													<Button
														variant="secondary"
														onClick={
															this
																.discardIsDirtyModal
														}
													>
														Discard
													</Button>
													<Button
														className="is-primary"
														variant="secondary"
														onClick={
															this
																.cancelIsDirtyModal
														}
													>
														Back
													</Button>
												</div>
											</Modal>
										</div>
									)}
								</Fragment>
							</div>
						</div>
						<div className="modal-buttons">
							<Button variant="secondary" onClick={this.close}>
								Cancel
							</Button>
							{showSpinner && <div className="modal-spinner"><Spinner /></div>}
							<Button
								disabled={!isDirty}
								variant="secondary"
								onClick={this.save}
							>
								Save Changes
							</Button>
						</div>
					</Modal>
				)}
			</Fragment>
		);
	}
}
